<div class="main-container" data-cy="check-in-container">

  @if (isLoading) {
    <div class="spinner-container" data-cy="check-in-loading">
      <mat-spinner data-cy="check-in-spinner"></mat-spinner>
    </div>
  }

  @if (!isLoading && showSuccess) {
    <div class="content-container mat-elevation-z2" data-cy="check-in-success-container">
      <div class="header" data-cy="check-in-success-header">
        Thank you for checking in!
      </div>
      <i class="material-icons success-icon" data-cy="check-in-success-icon">check</i>
    </div>
  }

  @if (!isLoading && !showSuccess) {
    <div class="content-container mat-elevation-z2" data-cy="check-in-scanner-container">
      <div class="header" data-cy="check-in-scanner-header">
        Please scan your QR code to check-in
      </div>
      <div class="scanner-container" data-cy="check-in-scanner">
        <zxing-scanner [enable]="enableScanner"
          [device]="activeDevice"
          (camerasFound)="camerasFoundHandler($event)"
          (scanSuccess)="scanSuccessHandler($event)"
        data-cy="check-in-zxing-scanner"></zxing-scanner>
      </div>
      <div class="device-selection-container" data-cy="check-in-device-selection-container">
        <mat-form-field class="device-selection" data-cy="check-in-device-form-field">
          <mat-label data-cy="check-in-device-label">Select a video device</mat-label>
          <mat-select [(ngModel)]="activeDevice" (ngModelChange)="selectedDevice()" data-cy="check-in-device-select">
            @for (device of activeDevices; track device) {
              <mat-option [value]="device" data-cy="check-in-device-option">
                {{ device.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  }



  <!--<button mat-raised-button color="primary" (click)="test()">test</button>-->

</div>
